import { useQuery } from '@tanstack/react-query';
import changePaymentMethodService from 'v2/services/changePaymentMethod';
import type { AutomaticPixAuthorization } from 'v2/services/changePaymentMethod';

const QUERY_KEY = 'automatic-pix-authorization';

function useAutomaticPixAuthorization(subscriptionId?: string) {
  return useQuery<AutomaticPixAuthorization>({
    queryKey: [QUERY_KEY, subscriptionId],
    queryFn: () => changePaymentMethodService.getAutomaticPixAuthorization(subscriptionId as string),
    enabled: !!subscriptionId,
    retry: false
  });
}

export { useAutomaticPixAuthorization };
